import React from "react";
import {
  Box,
  Typography,
  Container,
  Paper,
  Grid,
} from "@mui/material";

const AcademicFoundation = () => {
  return (
    <Box sx={{ backgroundColor: "#f2f2f2", py: 5,px:{xs:"auto",md:'50px'}}}>
      <Container >

        {/* SECTION TITLE */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            mb: 4,
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Playfair Display', serif !important",
              fontSize: {xs:"20px",md:"38px"},
              fontWeight: "600 !important",
              color: "#0f2e4d !important",
              whiteSpace: "nowrap",
            }}
          >
            Academic Foundation
          </Typography>

          <Box
            sx={{
              flex: 1,
              height: "1px",
              background:
                "linear-gradient(to right, #0f63a5, transparent)",
            }}
          />
        </Box>

        {/* EDUCATION CARDS */}
        {educationData.map((edu, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              backgroundColor: "#f7f7f7",
              borderRadius: "12px",
              p: 3,
              borderLeft: "6px solid #0f63a5",
              boxShadow: "0 2px 6px rgba(0,0,0,0.06)",
              mb: 3,
            }}
          >
            <Grid container alignItems="center">
              {/* LEFT CONTENT */}
              <Grid item xs={12} md={9}>
                <Typography
                  sx={{
                    fontFamily: "'Playfair Display', serif !important",
                    fontSize: "18px !important",
                    fontWeight: "600 !important",
                    color: "#0f2e4d !important",
                    textAlign:'start'
                  }}
                >
                  {edu.institution}
                </Typography>

                <Typography
                  sx={{
                    fontFamily: "'Lato', sans-serif !important",
                    fontSize: "14px !important",
                    color: "#0f63a5 !important",
                    fontWeight: "500 !important",
                    mt: 0.5,
                    textAlign:'start'
                  }}
                >
                  {edu.degree}
                </Typography>
              </Grid>

              {/* RIGHT YEAR */}
              <Grid
                item
                xs={12}
                md={3}
                sx={{
                  textAlign: { xs: "left", md: "right" },
                  mt: { xs: 1, md: 0 },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "'Lato', sans-serif !important",
                    fontSize: "14px !important",
                    color: "#555 !important",
                  }}
                >
                  {edu.year}
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        ))}
      </Container>
    </Box>
  );
};

export default AcademicFoundation;


/* ---------- DATA ---------- */

const educationData = [
  {
    institution: "Lincoln University (Oakland, CA)",
    degree:
      "Masters In Business Administration, International Business",
    year: "2008 - 2010",
  },
  {
    institution: "St. Joseph's Degree & P.G College",
    degree:
      "Bachelor's Degree, Business Administration, Management and Operations",
    year: "2003 - 2006",
  },
  {
    institution: "Little Flower Junior College",
    degree:
      "Bachelor's degree, Mathematics, Economics & Commerce",
    year: "2001 - 2003",
  },
];